// Remember the GrooveSell page that was open so the dashboard login callback
// can come back here instead of leaving the person on the Groove.cm dashboard.
export function rememberGrooveSellReturn(storage, href) {
  if (!storage || typeof href !== 'string' || !href || href.length > 2048) return;
  storage.setItem('redirect', href);
}

export function grooveSellUrl(origin, fullPath, development) {
  const path = typeof fullPath === 'string' && fullPath.startsWith('/')
    ? fullPath
    : `/${fullPath || ''}`;
  const prefix = development ? '' : '/groovesell';
  return `${origin}${prefix}${path}`;
}
